import teacherPages from './teacher' 
import adminPages from './admin'

const roles = {
  teacher: teacherPages,
  admin: adminPages
}

export default roles
